// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { teacupWithHelpers } from 'app/scripts/views/internal/teacupWithHelpers';
const t = teacupWithHelpers('popover_move_list');

// eslint-disable-next-line @trello/no-module-logic
export const PopoverMoveListTemplate = t.renderable(function ({
  organizations,
  hasEnterprise,
  enterpriseName,
  restrictToCurrentBoard,
}: // eslint-disable-next-line @typescript-eslint/no-explicit-any
any) {
  t.div('.form-grid', function () {
    t.div(
      '.form-grid-child.form-grid-child-full',
      {
        class: t.classify({
          hide: !restrictToCurrentBoard,
        }),
      },
      function () {
        t.label(() => t.format('board'));
        return t.p(() => t.text(organizations[0].boards[0].name));
      },
    );
    return t.div(
      '.button-link.setting.form-grid-child.form-grid-child-full',
      {
        class: t.classify({
          hide: restrictToCurrentBoard,
        }),
      },
      function () {
        t.span('.label', () => t.format('board'));
        t.span('.value.js-board-value');
        t.label(() => t.format('board'));
        return t.select('.js-select-board', () =>
          Array.from(organizations).map((org) =>
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            t.optgroup({ label: org.displayName }, () =>
              // @ts-expect-error TS(2571): Object is of type 'unknown'.
              Array.from(org.boards).map((board) =>
                t.optionSelected(
                  // @ts-expect-error TS(2571): Object is of type 'unknown'.
                  board.selected,
                  // @ts-expect-error TS(2571): Object is of type 'unknown'.
                  { value: board.id },
                  function () {
                    // @ts-expect-error TS(2571): Object is of type 'unknown'.
                    t.text(board.name);
                    // @ts-expect-error TS(2571): Object is of type 'unknown'.
                    if (board.selected) {
                      t.text(' ');
                      return t.format('current');
                    }
                  },
                ),
              ),
            ),
          ),
        );
      },
    );
  });

  if (hasEnterprise && enterpriseName) {
    t.p('.quiet', () =>
      t.format('list-can-only-be-moved-to-teams-within-org', {
        enterpriseName,
      }),
    );
  }

  t.div('.form-grid', () =>
    t.div(
      '.button-link.setting.form-grid-child.form-grid-child-full',
      function () {
        t.span('.label', () => t.format('position'));
        t.span('.value.js-pos-value');
        t.label(() => t.format('position'));
        return t.select('.js-select-list-pos');
      },
    ),
  );

  t.input('.nch-button.nch-button--primary.wide.js-commit-position', {
    type: 'submit',
    value: t.l('move'),
  });
  return t.p(() =>
    t.span('.error.hide.js-list-limit-exceeded', () =>
      t.format('too many lists'),
    ),
  );
});
